import { createTimedTracker } from '@gonfalon/analytics/createTimedTracker';
import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { EventLocation } from '@gonfalon/analytics/types';

import type { FilterKind } from '#components/ui/multipleFilters/types';
import type { Member } from '#utils/members/records/Member';

// oxlint-disable-next-line typescript/no-explicit-any
export const trackFlagEvent = (event: string, attributes?: any) => createTrackerForCategory('Flags')(event, attributes);

export const trackEditMaintainerHeaderButtonClicked = (kind?: 'member' | 'team') =>
  trackFlagEvent('Edit Maintainer Header Button Clicked', { kind });

export const trackEditMaintainerNameLinkClicked = (kind: 'member' | 'team') =>
  trackFlagEvent('Maintainer Name Link Clicked', { kind });

export const trackNewMaintainerSelectedFromDropdown = (kind: 'team' | 'member') =>
  trackFlagEvent('New Maintainer Selected From Dropdown', { kind });

// Event for Track Filter Value Change
// kind: identifies whether the selection was 'me' (current user), 'member', or 'team'
// location: where in the app this filter change occurred
export const trackFilterValueChange = (
  filterKind: FilterKind,
  options?: { kind?: 'me' | 'member' | 'team'; location?: EventLocation | '' },
) => {
  trackFlagEvent('Filter Value Change', { filterKind, ...options });
};

export const trackFlagMaintainerUpdated = (
  kind: 'team' | 'member' | undefined,
  location: 'maintainer modal' | 'flag settings form',
) => trackFlagSettingsEvent('Flag Maintainer Updated UI', { location, kind });

export const timedFlagTargetingEvents = {
  TIME_TO_SAVE_FLAG_CONFIGURATION: 'Time to save flag configuration',
  TIME_ON_REVIEW_AND_SAVE: 'Time to review and save flag configuration',
} as const;
export const trackFlagTargetingEvent = createTimedTracker('FlagsTargeting');
export const trackFlagListToolbarEvent = createTrackerForCategory('FlagListToolbar');
export const trackFlagListEvent = createTrackerForCategory('FlagList');
export const trackFlagOverviewEvent = createTrackerForCategory('FlagOverview');
export const trackFlagSettingsEvent = createTrackerForCategory('Flag Settings');

// Indicates whether the selected value is a team or a member or the currently logged in member "me".
export const getSelectedMaintainerKindForAnalytics = (
  maintainerKind: 'member' | 'team',
  value?: string,
  loggedInProfile?: Member,
) => (maintainerKind === 'member' && value === loggedInProfile?._id ? 'me' : maintainerKind);
